import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import SidebarContext from 'components/Sidebar/SidebarContext';
import {getFormattedDate} from "components/CoursePromo/helpers";
import {DateFormat} from "components/CoursePromo/types";
import moment from "moment";
import {transition} from "helpers/css";
import {useRoute} from "react-router5";

const Container = styled.div<{
  active: boolean
}>`
  padding: 11px 22px;
  border-radius: 6px;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  background-color: ${({active, theme}) => active
    ? theme.variables.backgroundColor
    : 'transparent'
  };
  
  ${transition()};
  
  &:hover {
    background-color: ${({theme}) => theme.variables.backgroundColor};
  }
`;

const Title = styled.div`
  margin-bottom: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;
`;

const ProgressBox = styled.div`
  height: 3px;
  background-color: ${transparentize(.9, '#fff')};
  border-radius: 8px;
  overflow: hidden;
`;

const Progress = styled.div`
  height: 100%;
  background-color: ${({theme}) => theme.colors.primary};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const Validity = styled.div`
  display: grid;
  gap: 4px;
  margin-top: 10px;
  
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};
`;

/**
 * render tariffs menu item
 * @return {React.ReactElement}
 * @constructor
 */
export default function MenuItemTariffs(): React.ReactElement {
  const {route, router} = useRoute();
  const context = React.useContext(SidebarContext);

  const [
    isToggle,
    setToggle,
  ] = React.useState<boolean>(false);

  function renderTitle() {
    const _title = '5 клиентов'
    const res = `Тариф «${_title}»`
    return (
      <Title>{res}</Title>
    )
  }

  function renderProgress() {
    const percent = 57;

    return (
      <ProgressBox>
        <Progress style={{width: `${percent}%`}}/>
      </ProgressBox>
    )
  }



  function renderValidity() {
    const date = getFormattedDate(
      moment('22.10.2021', 'DD.MM.YYYY'),
      DateFormat.Dot
    );
    const activeUsers = 5;

    const dateElement = date
      ? <div>Действует до {date}</div>
      : null;

    return (
      <Validity>
        {dateElement}
        <div>Активных клиентов: {activeUsers}</div>
      </Validity>
    )
  }

  return (
    <Container
      active={route?.name === 'tariffs'}
      onClick={() => router.navigate('tariffs')}
    >
      {renderTitle()}
      {renderProgress()}
      {renderValidity()}
    </Container>
  );
}
